import withPropsOnChange from 'recompose/withPropsOnChange';
import withState from 'recompose/withState';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { t } from '../../../../modules/infra/i18n';
import withValidateSaleAction from '../../hoc/withValidateSaleAction';
import { getAppliedPromoCode, getOrderForValidation } from '../../selectors';
import { getCustomerId } from '../../customer/selectors';
import { resetPromoCode, setPromoCode } from '../../promo/actions';
import PromoCode from '../components/PromoCode';
import withNotifications from '../../../common/withNotifications';

const PromoCodeContainer = compose(
  withValidateSaleAction,
  withNotifications,
  withState('inputValue', 'setValue', ''),

  connect(
    (state, ownProps) => {
      const appliedPromoCode = getAppliedPromoCode(state);
      const customerId = getCustomerId(state);

      return {
        appliedPromoCode,
        disabled: !customerId || Boolean(appliedPromoCode),
        value: !customerId ? '' : (ownProps.inputValue || appliedPromoCode),
        placeholder: !customerId
          ? t('register:payment.promo_code.placeholder_select_client')
          : t('register:payment.promo_code.placeholder_add_code'),
        order: getOrderForValidation(state),
      };
    },
    { setPromoCode, resetPromoCode }
  ),

  withHandlers({
    onChange: props => e => props.setValue(e.target.value),
    onSubmit: props => (e) => {
      e.preventDefault();

      if (!props.inputValue) {
        props.addNotification({
          level: 'warning',
          title: t('register:payment.promo_code.notification_title'),
          message: t('register:payment.promo_code.notification_message'),
        });
        return;
      }

      props.validateSaleAction({
        ...props.order,
        promoCode: props.inputValue,
      }).then(() => {
        props.setPromoCode(props.inputValue);
      }).catch(() => {
        props.setValue('');
      });
    },
  }),

  withPropsOnChange(
    ['appliedPromoCode'],
    (props) => {
      props.setValue();
    }
  )

)(PromoCode);

export default PromoCodeContainer;
